import api from "./axios";

const EndPoints = {
  allTransaction(
    page: number,
    filterData: {
      to: string;
      from: string;
      status: string;
      min: number;
      max: number;
      currency: string;
      search: string;
    },
    normalSearch: string
  ) {
    let query = `/merchant/transactions?order=DESC&page=${page}&take=10`;
    if (filterData?.status) {
      query += `&status=${filterData?.status}`;
    }
    if (filterData?.from) {
      query += `&from=${filterData?.from}`;
    }
    if (filterData?.to) {
      query += `&to=${filterData?.to}`;
    }
    if (filterData?.min) {
      query += `&minAmount=${filterData?.min}`;
    }
    if (filterData?.max) {
      query += `&maxAmount=${filterData?.max}`;
    }
    if (filterData?.search) {
      query += `&search=${filterData?.search}`;
    }
    if (normalSearch) {
      query += `&search=${normalSearch}`;
    }
    if (filterData?.currency) {
      query += `&currency=${filterData?.currency}`;
    }
    return query;
  },
  report(reportData: {
    to: string;
    from: string;
    status: string;
    min: number;
    max: number;
    sharedReference: string;
  }) {
    let query = `/merchant/transactions?take=50&action=export`;
    if (reportData?.to) {
      query += `&to=${reportData?.to}`;
    }
    if (reportData?.from) {
      query += `&from=${reportData?.from}`;
    }
    if (reportData?.status) {
      query += `&status=${reportData?.status}`;
    }
    if (reportData?.min) {
      query += `&minAmount=${reportData?.min}`;
    }
    if (reportData?.max) {
      query += `&maxAmount=${reportData?.max}`;
    }
    if (reportData?.sharedReference) {
      query += `&sharedReference=${reportData?.sharedReference}`;
    }
    return query;
  },
  transaction(id: string) {
    return `/merchant/transactions/${id}`;
  },
  requeue(id: string) {
    return `/merchant/transactions/${id}/re-queue`;
  },
  refresh(id: string) {
    return `/merchant/transactions/${id}/refresh`;
  },
  mark(id: string) {
    return `/merchant/transactions/${id}/mark-as`;
  },
  complete(id: string) {
    return `/merchant/transactions/${id}/complete-transaction`;
  },
  completeSettlement(id: string) {
    return `/merchant/transactions/${id}/complete-settlement`;
  },
  updateBeneficiary(id: string) {
    return `/merchant/transactions/${id}/update-beneficiary`;
  },
  create: `/merchant/transactions/create`,
};

export const getAllTransaction = async (
  page: number,
  filterData: {
    to: string;
    from: string;
    search: string;
    status: string;
    min: number;
    max: number;
    currency: string;
  },
  normalSearch: string
) => {
  const res = await api.get(
    EndPoints.allTransaction(page, filterData, normalSearch)
  );
  return res;
};
export const getTransaction = async (id: string) => {
  const res = await api.get(EndPoints.transaction(id));
  return res;
};

export const generateReport = async (reportData: {
  to: string;
  from: string;
  status: string;
  min: number;
  max: number;
  sharedReference: string;
}) => {
  const res = await api.get(EndPoints.report(reportData));
  return res;
};

export const requeueTransaction = async (id: string) => {
  const res = await api.post(EndPoints.requeue(id));
  return res;
};
export const refreshTransaction = async (id: string, payload: unknown) => {
  const res = await api.post(EndPoints.refresh(id), payload);
  return res;
};
export const markATransaction = async (id: string, payload: unknown) => {
  const res = await api.post(EndPoints.mark(id), payload);
  return res;
};
export const complete = async (id: string) => {
  const res = await api.post(EndPoints.complete(id));
  return res;
};
export const updateTransaction = async (id: string, payload: unknown) => {
  const res = await api.post(EndPoints.completeSettlement(id), payload);
  return res;
};
export const updateBeneficiary = async (id: string, payload: unknown) => {
  const res = await api.post(EndPoints.updateBeneficiary(id), payload);
  return res;
};
export const createTransaction = async (payload: unknown) => {
  const res = await api.post(EndPoints.create, payload);
  return res;
};
